import { txt } from "../../services/translation";

export default function Tag({tag, onClick}){

    const style = {
        color: tag.color,
    };

    return <span 
        className='social-tag' 
        style={style}
        onClick={onClick}
    >
        {tag.type.id === 'category' ? txt(tag.code + 'Hashtag') : tag.hashtag}
    </span>
}
